import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/tvm',
  component: () => import('../../routes/TVM.svelte'),
  card: {
    id: 'tvm',
    title: 'TVM Calculator',
    description: 'Calculate future value with present value, payments, and interest rates using time value of money principles.',
    icon: 'calculate',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/tvm',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'TVM Calculator – Free Time Value of Money Calculator Online',
    description: 'Free TVM calculator online to compute future value, present value, payments, and interest rates. The best financial TVM calculator for time value of money calculations. Learn how to use a TVM calculator with examples. Simple, accurate, and free.',
  },
};

export default meta;
